export default class sorting {
  constructor() {
    $('.index--wrap--headers > span').unbind('click').click(function(e){
      e.preventDefault();

      var sortBy = null;

      $('.sort').not(this).removeClass('sort');
      $(this).toggleClass('sort');

      if($(this).hasClass('sort')) {
        var c = $(this).attr('class').split(' ')[0];
        if(c=='index--wrap--headers--project') {
          sortBy = 'title';
        } else if (c=='index--wrap--headers--client') {
          sortBy = 'client';
        } else if (c=='index--wrap--headers--type') {
          sortBy = 'type';
        }
      } else {
        sortBy = 'num';
      }

      $('.index--wrap--past, .index--wrap--future').each(function(){
        var theList = this;
        var listitems = $(theList).children('.index-project').get();
        let search = null;
        if(sortBy=='title') {
          if(MOBILE) {
            search = '.index-project--title--full';
          } else {
            search = '.index-project--title';
          }
        } else if(sortBy=='client') {
          search = '.index-project--client';
        } else if(sortBy=='type') {
          search = '.index-project--type';
        } else if(sortBy=='num') {
          search = '.index-project--num';
        }

        listitems.sort(function(a, b) {
          return $(a).find(search).text().toUpperCase().localeCompare($(b).find(search).text().toUpperCase());
        })
        $.each(listitems, function(idx, itm) { $(theList).append(itm); });
      });
    });
  }
}
